import type { ReactNode } from "react";

import type { BoxProps } from "@mui/material/Box";
import Box from "@mui/material/Box";

type Props = {
  children: ReactNode;
} & BoxProps;
export const Flex = ({ children, ...rest }: Props) => {
  return (
    <Box display={"flex"} {...rest}>
      {children}
    </Box>
  );
};
